<template>
  <div>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <box >
            <div slot="body">
                <ul class="nav nav-tabs">
                  <li class="active" id="empresa"><a href="javascript:;" @click="mudarAtivo('empresa')">DADOS DA EMPRESA</a></li>
                  <li class="" id="perfil"><a href="javascript:;" @click="mudarAtivo('perfil')">PERFIL DE USUÁRIO</a></li>
                  <li class="" id="pedidos"><a href="javascript:;" @click="mudarAtivo('pedidos')">PEDIDOS</a></li>
                  <li class="" id="funcionamento"><a href="javascript:;" @click="mudarAtivo('funcionamento')">FUNCIONAMENTO</a></li>
                  <!-- <li class="" id="clientes"><a href="javascript:;" @click="mudarAtivo('clientes')">CLIENTES</a></li> -->
                  <!-- <li class="" id="produtos"><a href="javascript:;" @click="mudarAtivo('produtos')">PRODUTOS</a></li> -->
                  <!-- <li class="" id="categorias"><a href="javascript:;" @click="mudarAtivo('categorias')">CATEGORIAS</a></li> -->
                  <!-- <li class="" id="promocao"><a href="javascript:;" @click="mudarAtivo('promocao')">GERENCIADOR DE PROMOÇÕES</a></li> -->
                </ul>

                <br>

                <!--     DADOS DA EMPRESA     -->
                <div v-show="ativo === 'empresa'">
                  <Circle8 class="spinner" v-show="loading"></Circle8>
                  <ul type="none" v-show="!loading">
                    <li class="row">
                      <div class="col-sm-5">
                        CEP:
                        <input type="number" class="form-control" v-model="cep">
                      </div>
                      <br>
                      <button class="btn" @click="buscaCEP">Buscar Endereco</button>
                    </li>
                    <li>
                      RUA:
                      <input type="text" class="form-control inputEndereco" v-model="rua" >
                    </li>
                    <li>
                      NUMERO:
                      <input type="number" class="form-control inputEndereco" v-model="numero">
                    </li>
                    <li>
                    <li>
                      BAIRRO:
                      <input type="text" class="form-control inputEndereco" v-model="bairro">
                    </li>
                    <li>
                      CIDADE:
                      <input type="text" class="form-control inputEndereco" v-model="cidade">
                    </li>
                    <li>
                      ESTADO:
                      <div class="form-group inputEndereco">
                        <select class="form-control" id="sel1" v-model="estado">
                          <option>AC</option>
                          <option>AL</option>
                          <option>AP</option>
                          <option>AM</option>
                          <option>BA</option>
                          <option>CE</option>
                          <option>DF</option>
                          <option>ES</option>
                          <option>GO</option>
                          <option>MA</option>
                          <option>MT</option>
                          <option>MS</option>
                          <option>MG</option>
                          <option>PA</option>
                          <option>PB</option>
                          <option>PR</option>
                          <option>PE</option>
                          <option>PI</option>
                          <option>RJ</option>
                          <option>RN</option>
                          <option>RS</option>
                          <option>RO</option>
                          <option>RR</option>
                          <option>SC</option>
                          <option>SP</option>
                          <option>SE</option>
                          <option>TO</option>
                        </select>
                      </div>
                    </li>
                    <li>
                      COMPLEMENTO:
                      <input type="text" class="form-control inputEndereco" v-model="complemento">
                    </li>
                  </ul>
                </div>

                <!-- PERMISSÃO DE PERFIL -->
                <div v-show="ativo === 'perfil'">
                  <ul type="none">
                    <li class="row">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input type="checkbox" class="form-check-input" v-model="permite_impressao" true-value="true" false-value="false">
                          1. Permite Impressão de Pedido automaticamente
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input type="checkbox" class="form-check-input" v-model="permite_email" true-value="true" false-value="false">
                          2. Permite o envio de e-mail de notificação ao cliente enviar dúvida
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>

                <!--       CONFIGURAÇÃO DE PEDIDOS       -->
                <div v-show="ativo === 'pedidos'">
                  <ul type="none">
                    <li class="row">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input type="checkbox" class="form-check-input" v-model="config.notifica_cliente" true-value="true" false-value="false">
                          1. Notifica o cliente sobre alteração de status
                        </label>
                      </div>
                      <ul type="none">
                        <li>
                          <h6><a href="javascript:;" @click="tabelaVariaveis">Tabela de Variáveis</a></h6>
                        </li>
                        <li>
                          <div class="form-group">
                            <label>1.1 Texto padrão para notificação de status APROVADO</label>
                            <textarea class="form-control textarea" rows="3" v-model="config.texto_padrao_aprovado" >{{config.texto_padrao_aprovado}} </textarea>
                          </div>
                        </li>
                        <li>
                          <div class="form-group">
                            <label>1.2 Texto padrão para notificação de status REPROVADO</label>
                            <textarea class="form-control textarea" rows="3" v-model="config.texto_padrao_reprovado" >{{config.texto_padrao_reprovado}}</textarea>
                          </div>
                        </li>
                        <li>
                          <div class="form-group">
                            <label>1.3 Texto padrão para notificação de status CANCELADO</label>
                            <textarea class="form-control textarea" rows="3" v-model="config.texto_padrao_cancelado" >{{config.texto_padrao_cancelado}}</textarea>
                          </div>
                        </li>
                        <li>
                          <div class="form-group">
                            <label>1.4 Texto padrão para notificação de status SAIU PARA ENTREGA</label>
                            <textarea class="form-control textarea" rows="3" v-model="config.texto_padrao_entrega" >{{config.texto_padrao_entrega}}</textarea>
                          </div>
                        </li>
                      </ul>
                    </li><br>
                    <li>
                      <div class="form-group">
                        <label>2. Raio de Entrega dos pedidos (Km)</label>
                        <div v-if="frete.length > 0" >
                          <div v-for="(item, index) in frete" style="display: flex">
                            <h5>Até</h5><input type="number" class="form-control inputFrete" v-model="item.distancia"><h5>km, cobrar R$</h5><input type="number" class="form-control inputFrete" v-model="item.valor">
                            <a v-if="index === 0" @click="adicionarFrete"><h5 class="inputRaioEntrega">Novo Raio de Entrega</h5></a>
                            <a @click="removerFrete(index)" v-else class="removeFrete"><i class="fa fa-times-circle" aria-hidden="true"></i></a>
                          </div>
                        </div>
                        <div v-else style="display: flex">
                          <h5>Até</h5><input type="number" class="form-control inputFrete" v-model="config.raio_entrega"><h5>km, cobrar R$</h5><input type="number" class="form-control inputFrete" v-model="config.taxa_entrega">
                        </div>
                      </div>
                    </li>
                    <li>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="config.imprimir_descricao" true-value="true" false-value="false">
                            3. Imprimir descrição do produto no Recibo.
                          </label>
                        </div>
                    </li><br>
                    <li>
                      <div class="form-check">
                          <label class="form-check-label">
                            4. Valor mínimo para pedidos
                            <input type="number" class="form-control" v-model="config.pedido_minimo">
                          </label>
                        </div>
                    </li>
                  </ul>
                </div>

                <!-- CONFIGURAÇAO DE FUNCIONAMENTO  -->
                <div v-show="ativo === 'funcionamento'">
                  <ul type="none">
                    <li class="row">
                      <ul type="none">
                        <li v-for="linha in funcionamento">
                          <div class="form-check">
                            <label class="form-check-label">
                              <input type="checkbox" class="form-check-input" v-model="linha.aberto" :true-value="true" :false-value="false">
                              {{linha.dia.toUpperCase()}}
                            </label>
                          </div>
                          <ul type="none">
                            <div v-show="linha.aberto">
                              <input type="time" v-model="linha.hr_abertura_1"/> às <input type="time" v-model="linha.hr_fechamento_1"/> &nbsp  - &nbsp <input type="time" v-model="linha.hr_abertura_2"/> às <input type="time" v-model="linha.hr_fechamento_2"/>
                            </div>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                 <!--      CONFIGURAÇÃO DE PROMOÇÕES     -->
                <div v-show="ativo === 'promocao'">
                  <ul type="none">
                    <li class="row">
                      <div class="form-check">
                        <label class="form-check-label">
                          <!-- <input type="checkbox" class="form-check-input" v-model="promocao[0].ativo" true-value="true" false-value="false"> -->
                          1. Promoção Por Período
                        </label>
                      </div>
                      <ul type="none">
                        <li class="row">
                          1.1. Promoção ativa entre 
                          <!-- <input type="date" v-model="promocao[0].dt_inicio"> e <input type="date" v-model="promocao[0].dt_fim">  -->
                        </li><br>
                        <li class="row">
                          <div class="col-sm-3 noPadding">
                            1.2. Promoção válida para pedidos acima de 
                          </div>
                          <div class="col-sm-1" style="margin-left:-3%" >
                            <!-- <input type="number" class="form-control " v-model="promocao[0].valor">  -->
                          </div>
                          reais
                        </li><br>
                        <li>
                          <label class="radio-inline"><input type="radio" name="optradio1" v-model="optradio1" value="item" >Item Brinde</label>
                          <label class="radio-inline"><input type="radio" name="optradio1" v-model="optradio1" value="desc" >Desconto</label>
                        </li>
                        <li v-show="optradio1 === 'desc'">
                            1.3. Porcentagem de desconto
                            <!-- <input type="number" class="form-control inputTaxa" v-model="promocao[0].desconto"> -->
                        </li>
                      </ul>
                    </li>

                    <br><br>
                    
                    <li class="row">
                      <div class="form-check">
                        <label class="form-check-label">
                          <!-- <input type="checkbox" class="form-check-input"  true-value="true" false-value="false" v-model="promocao[2].ativo"> -->
                          2. Promoção Por Pedidos Realizados
                        </label>
                      </div>
                      <ul type="none">
                        <li class="row">
                          <div class="col-sm-1 noPadding">
                            2.1. A partir de
                          </div>
                          <div class="col-sm-1">
                            <!-- <input type="number" class="form-control" v-model="promocao[2].qtde_pedidos"> -->
                          </div> pedidos
                        </li>
                      </ul>
                      <ul type="none">
                        <li>
                          <label class="radio-inline"><input type="radio" name="optradio2" v-model="optradio2" value="item" >Item Brinde</label>
                          <label class="radio-inline"><input type="radio" name="optradio2" v-model="optradio2" value="desc" >Desconto</label>
                        </li>
                      </ul>
                      <ul type="none">
                        <li v-show="optradio2 === 'desc'">
                            2.2. Porcentagem de desconto
                            <!-- <input type="number" class="form-control inputTaxa" v-model="promocao[2].desconto"> -->
                        </li>
                      </ul>
                    </li>

                    <br><br>
                    
                    <li class="row">
                      <div class="form-check">
                        <label class="form-check-label">
                          <!-- <input type="checkbox" class="form-check-input"  true-value="true" false-value="false" v-model="promocao[1].ativo"> -->
                          3. Promoção de Aniversário
                        </label>
                      </div>
                      <ul type="none">
                        <li>
                          <label class="radio-inline"><input type="radio" name="optradio3" v-model="optradio3" value="item" >Item Brinde</label>
                          <label class="radio-inline"><input type="radio" name="optradio3" v-model="optradio3" value="desc" >Desconto</label>
                        </li>
                      </ul>
                      <ul type="none">
                        <li v-show="optradio3 === 'desc'">
                            3.1. Porcentagem de desconto
                            <!-- <input type="number" class="form-control inputTaxa" v-model="promocao[1].desconto"> -->
                        </li>
                      </ul>
                    </li>
                  </ul>  
                  <br><br>
                </div>

                <button v-show="!gravando" class="btn btn-primary" @click="gravarConfig"><i class="fa fa-check"></i>  Gravar</button>
                <button v-show="gravando" class="btn btn-primary" @click="gravarConfig"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
            </div>

           
          </box>

        </div>
      </div>
    </section>
  </div>
</template>
<script>
import $ from 'jquery'
import axios from 'axios'
import Box from './Box'
import {Circle8} from 'vue-loading-spinner'

export default {
  name: 'Settings',
  components: {
    'box': Box,
    Circle8
  },
  data () {
    return {
      sorter: {
        "segunda": 1,
        "terca": 2,
        "quarta": 3,
        "quinta": 4,
        "sexta": 5,
        "sabado": 6,
        "domingo": 7
      },
      ativo: 'empresa',
      config: [],
      permite_email: this.$store.state.permite_email,
      permite_impressao: this.$store.state.permite_impressao,
      funcionamento: [],
      gravando: false,
      optradio1: '',
      optradio2: '',
      optradio3: '', 
      promocao: [],
      rua: '',
      numero: 0 ,
      cidade:'',
      estado:'SP',
      cep: 0,
      complemento:'',
      bairro:'',
      loading: true,
      frete: []
    }
  },
  watch: {
    'config.funcionamento': function (val) {
      if (val==='auto' && this.funcionamento.length === 0) {
        this.Funcionamento()
      }
    }
  },
  created () {
    this.getConfig()
    this.getPromocao()
    this.getEmpresa()
    this.getFrete()
    this.Funcionamento()
  },
  methods: {
    getConfig() {
      axios.get(`${this.$store.state.api}config?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.config = response.data[0]
        console.log('config:',this.config)
      })
    },
    Funcionamento () {
      axios.get(`${this.$store.state.api}funcionamento?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        // console.log('funcionamento-> ', response)
        this.funcionamento = response.data
        this.funcionamento.sort((a, b) => {
          let day1 = a.dia.toLowerCase();
          let day2 = b.dia.toLowerCase();
          return this.sorter[day1] - this.sorter[day2];
        });
        console.log('week = > ', this.funcionamento)
      })
    },
    getPromocao(){
      axios.get(`${this.$store.state.api}promocao?empresa=${this.$store.state.empresa_fb_id}`).then(response=> {
        console.log('promocao', response.data)
        if(response.data.length > 0) {
          this.promocao = response.data
          this.optradio1 = this.promocao[0].tipo
          this.optradio2 = this.promocao[2].tipo
          this.optradio3 = this.promocao[1].tipo
        }
      })
    },
    getEmpresa() {
      // console.log('empresa:',this.$store.state.empresa_id)
      axios.post('https://sev-delivery.herokuapp.com/api/empresas', {
        'empresa': this.$store.state.empresa_fb_id
      }).then(response=> {
        if (response.data.endereco) {
          let endereco = response.data.endereco.split(',')
          // console.log('endereco:', response.data[0].endereco)
          this.rua = endereco[0]
          this.numero = Number(endereco[1])
          this.bairro = endereco[2]
          this.cidade = endereco[4]
          this.estado = endereco[5].replace(' ','').substring(0,2)
          this.cep = Number(endereco[6])
          this.complemento = endereco[3]
        }
          this.loading = false
      })
    },
    getFrete() {
      axios.get(`${this.$store.state.api}frete?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        // console.log('frete-> ', response)
        this.frete = response.data
      })
    },
    adicionarFrete() {
      console.log('adicionar')
      this.frete.push({
        valor: 0,
        distancia: 0
      })
    },
    removerFrete(index) {
      this.frete.splice(index, 1)
    },
    mudarAtivo (id) {
      $('.active').removeClass('active')
      document.getElementById(id).className = 'active'
      this.ativo = id
    },
    buscaCEP(){
      axios.get('https://viacep.com.br/ws/'+this.cep+'/json/').then(response=>{
        let endereco = response.data
        this.rua = endereco.logradouro
        this.cidade = endereco.localidade
        this.estado = endereco.uf
      })
    },
    atualizarCron() {
      axios.get('https://senhor-destino.herokuapp.com/restart')
    },
    gravarConfig () {
      this.gravando = true

      let url = 'https://sev-delivery.herokuapp.com/api/usuarios/' + this.$store.state.email;
      axios.put(url, {
        'permite_impressao': this.permite_impressao,
        'permite_email': this.permite_email
      }).then((res) => {
        console.log(res)
        // window.localStorage.removeItem('usuario');
        window.localStorage.removeItem('response');
      })

      if(this.frete.length > 0) axios.post(this.$store.state.api+'frete', { frete: this.frete, empresa: this.$store.state.empresa_fb_id });
      
      axios.post(this.$store.state.api+'config/save-config', this.montarConfig()).then(response => {
        if (response.data.success) {
          this.gravarEmpresa().then((response) => {
            if (response) {
              this.gravarFuncionamento().then((response) => {
                if (response) {
                  this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Configurações Salvas',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  this.atualizarCron()
                  this.gravando = false
                  // this.$router.go()
                } else {
                  this.$swal(
                    'Ops!',
                    'Problemas na gravação da Funcionalidade.',
                    'error'
                  )
                  this.gravando = false
                }
              })
            } else {
                this.$swal(
                  'Ops!',
                  'Problemas na gravação da empresa.',
                  'error'
                )
                this.gravando = false
              }
          })
        } else {
          this.$swal(
            'Ops!',
            'Problemas na gravação. Nenhuma alteração realizada.',
            'error'
          )
          this.gravando = false
        }
      });
    },
    montarConfig() {
      let config = {};
      config['notifica_cliente'] = this.config.notifica_cliente;
      config['texto_padrao_aprovado'] = this.config.texto_padrao_aprovado;
      config['texto_padrao_reprovado'] = this.config.texto_padrao_reprovado;
      config['texto_padrao_cancelado'] = this.config.texto_padrao_cancelado;
      config['texto_padrao_entrega'] = this.config.texto_padrao_entrega;
      config['imprimir_descricao'] = this.config.imprimir_descricao;
      if(this.frete.length === 0) {
        config['taxa_entrega'] = this.config.taxa_entrega;
        config['raio_entrega'] = parseInt(this.config.raio_entrega);
      }
      config['funcionamento'] = this.config.funcionamento;
      config['empresa'] = this.$store.state.empresa_fb_id;
      config['pedido_minimo'] = this.config.pedido_minimo

      return config;
    },
    gravarEmpresa () {
      let endereco = this.rua +','+this.numero +','+this.bairro+','+this.complemento+','+this.cidade +','+this.estado +','+this.cep
      return axios.post('https://sev-delivery.herokuapp.com/api/empresas/save', {
        'endereco': endereco,
        'id': this.$store.state.empresa_id
      }).then(response => {
          if (response.data.success) {
            return true
          } else {
            return false
          }
      })
    },
    gravarFuncionamento () {
      let segunda, terca, quarta, quinta, sexta, sabado, domingo
      this.funcionamento.forEach((element, index, array) => {
        switch (element.dia) {
          case 'segunda': segunda = index
            break;
          case 'terca': terca = index
            break;
          case 'quarta': quarta = index
            break;
          case 'quinta': quinta = index
            break;
          case 'sexta': sexta = index
            break;
          case 'sabado': sabado = index
            break;
          case 'domingo': domingo = index
            break;
        }
      }) 
      return axios.put(this.$store.state.api + 'funcionamento', {
        'empresa': this.$store.state.empresa_fb_id,
        'segunda': this.funcionamento[segunda].aberto,
        'hr_abertura_segunda_1': this.funcionamento[segunda].hr_abertura_1,
        'hr_abertura_segunda_2': this.funcionamento[segunda].hr_abertura_2,
        'hr_fechamento_segunda_1': this.funcionamento[segunda].hr_fechamento_1,
        'hr_fechamento_segunda_2': this.funcionamento[segunda].hr_fechamento_2,
        'terca': this.funcionamento[terca].aberto,
        'hr_abertura_terca_1': this.funcionamento[terca].hr_abertura_1,
        'hr_abertura_terca_2': this.funcionamento[terca].hr_abertura_2,
        'hr_fechamento_terca_1': this.funcionamento[terca].hr_fechamento_1,
        'hr_fechamento_terca_2': this.funcionamento[terca].hr_fechamento_2,
        'quarta': this.funcionamento[quarta].aberto,
        'hr_abertura_quarta_1': this.funcionamento[quarta].hr_abertura_1,
        'hr_abertura_quarta_2': this.funcionamento[quarta].hr_abertura_2,
        'hr_fechamento_quarta_1': this.funcionamento[quarta].hr_fechamento_1,
        'hr_fechamento_quarta_2': this.funcionamento[quarta].hr_fechamento_2,
        'quinta': this.funcionamento[quinta].aberto,
        'hr_abertura_quinta_1': this.funcionamento[quinta].hr_abertura_1,
        'hr_abertura_quinta_2': this.funcionamento[quinta].hr_abertura_2,
        'hr_fechamento_quinta_1': this.funcionamento[quinta].hr_fechamento_1,
        'hr_fechamento_quinta_2': this.funcionamento[quinta].hr_fechamento_2,
        'sexta': this.funcionamento[sexta].aberto,
        'hr_abertura_sexta_1': this.funcionamento[sexta].hr_abertura_1,
        'hr_abertura_sexta_2': this.funcionamento[sexta].hr_abertura_2,
        'hr_fechamento_sexta_1': this.funcionamento[sexta].hr_fechamento_1,
        'hr_fechamento_sexta_2': this.funcionamento[sexta].hr_fechamento_2,
        'sabado': this.funcionamento[sabado].aberto,
        'hr_abertura_sabado_1': this.funcionamento[sabado].hr_abertura_1,
        'hr_abertura_sabado_2': this.funcionamento[sabado].hr_abertura_2,
        'hr_fechamento_sabado_1': this.funcionamento[sabado].hr_fechamento_1,
        'hr_fechamento_sabado_2': this.funcionamento[sabado].hr_fechamento_2,
        'domingo': this.funcionamento[domingo].aberto,
        'hr_abertura_domingo_1': this.funcionamento[domingo].hr_abertura_1,
        'hr_abertura_domingo_2': this.funcionamento[domingo].hr_abertura,
        'hr_fechamento_domingo_1': this.funcionamento[domingo].hr_fechamento_1,
        'hr_fechamento_domingo_2': this.funcionamento[domingo].hr_fechamento_2,
      }).then(response => {
        if(response.data.success) {
          return true
        } else {
          return false
        }
      })
    },
    tabelaVariaveis () {
      this.$swal({
        title:'Variáveis',
        html: '<div style="text-align: left">' +
              '#NOME = Primeiro nome do cliente <br><br>'+
              '#SOBRENOME = Sobrenome do cliente <br><br>'+
              '#IDPEDIDO = ID do Pedido <br><br>'+
              '#FACEID = ID do Facebook do cliente <br><br>'+
              '#PRECOTOTAL = Preço Total do pedido <br><br>'+
              '#TEMPOENTREGA = Tempo de entrega informado na tela inicial' +
              '</div>'
      })

    }
  }
}
</script>

<style>
.textarea {
  width: 420px;
}
.inputTaxa{
  width: 10%
}
.inputFrete {
  width: 7%;
  margin-left: 5px; 
  margin-right: 5px; 
}
.noPadding{
  padding: 0px
}
.inputEndereco{
  width: 40%
}
.inputRaioEntrega:hover {
  cursor: pointer;
}
.removeFrete {
  margin-top: 10px;
}
.removeFrete:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Setting.vue?21717ea8